import PropTypes from 'prop-types';


// ------ shapes
export const SHAPE_EMAIL = PropTypes.string;
